// extracted by mini-css-extract-plugin
export default {"status":"style_status__4O0+7","prev":"style_prev__6dw2P","current":"style_current__2sjSa","next":"style_next__6k7qb"};